module.exports = __webpack_public_path__ + "f9365cce7cdc699986a7adfaf569b567.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_0_0.ttf
// module id = 530
// module chunks = 0